/* eslint-disable no-console */
const isDev = process.env.NODE_ENV !== 'production'

const noop = () => {}

const logger = {
  error: (...args) => console.error(...args),
  warn: (...args) => console.warn(...args),
  info: isDev ? (...args) => console.info(...args) : noop,
  debug: isDev ? (...args) => console.debug(...args) : noop,
}

export default logger
